import { Alert, Button, Checkbox, Input, Label } from '@agion/ui'
import { useTranslation } from 'react-i18next'
import { validSshAccess, type SshAccessMode } from './vmDeployment'

/** Shared creation/reapply policy control; no public IP is introduced here. */
export function AzureSshAccess({ mode, sources, onModeChange, onSourcesChange }: {
  mode: SshAccessMode
  sources: string
  onModeChange: (mode: SshAccessMode) => void
  onSourcesChange: (sources: string) => void
}) {
  const { t } = useTranslation()
  return <div className="space-y-4">
    {mode !== 'legacy' && <p className="text-sm text-slate-600 dark:text-slate-400">
      {t('pages:sshAccess.vpnHint')}
    </p>}
    {mode === 'legacy' && <Alert variant="warning">
      <p>{t('pages:sshAccess.legacyHint')}</p>
      <Button type="button" variant="outline" className="mt-3" onClick={() => onModeChange('vpn_only')}>
        {t('pages:sshAccess.useVpn')}
      </Button>
    </Alert>}
    <details className="space-y-4" open={mode !== 'vpn_only' || undefined}>
      <summary className="cursor-pointer text-sm font-medium">{t('pages:sshAccess.advanced')}</summary>
      {mode !== 'legacy' && <Label className="flex items-center gap-2">
        <Checkbox checked={mode === 'private_network'} onCheckedChange={(checked) => onModeChange(checked === true ? 'private_network' : 'vpn_only')} />
        {t('pages:sshAccess.allowDirect')}
      </Label>}
      {mode !== 'vpn_only' && <div className="space-y-2">
        <Label htmlFor="vm-ssh-cidrs">{t('pages:vmWizard.sshRanges', 'Allowed SSH source ranges')}</Label>
        <Input id="vm-ssh-cidrs" value={sources} required={mode === 'private_network'}
          aria-invalid={!validSshAccess(mode, sources)}
          onChange={(event) => onSourcesChange(event.target.value)} />
        <p className="text-sm text-slate-500">{t(mode === 'legacy' ? 'pages:sshAccess.legacySources' : 'pages:sshAccess.sourcesHint')}</p>
      </div>}
    </details>
  </div>
}
